export interface InsightCursor {
  sheetName: string | null;
  position: number;
}

export function insightPosition(
  entrySheets: readonly string[],
  sheetName: string | null,
  cursor: InsightCursor | null,
): number {
  // Entries are immutable within a workbook version; array positions identify duplicates too.
  if (cursor?.sheetName === sheetName
    && (cursor.position === entrySheets.length || entrySheets[cursor.position] === sheetName)) {
    return cursor.position;
  }
  return entrySheets.findIndex(name => name === sheetName);
}

export function nextInsightPosition(
  entrySheets: readonly string[],
  sheetNames: readonly string[],
  sheetName: string | null,
  position: number,
): number {
  if (position >= 0) return Math.min(position + 1, entrySheets.length);
  const sheetIndex = sheetName === null ? -1 : sheetNames.indexOf(sheetName);
  const next = entrySheets.findIndex(name => sheetNames.indexOf(name) > sheetIndex);
  return next >= 0 ? next : 0;
}

export function previousInsightPosition(
  entrySheets: readonly string[],
  sheetNames: readonly string[],
  sheetName: string | null,
  position: number,
): number {
  if (entrySheets.length === 0) return -1;
  if (position === entrySheets.length) return entrySheets.length - 1;
  if (position > 0 && position < entrySheets.length) return position - 1;
  if (position === 0) return -1;

  const sheetIndex = sheetName === null ? -1 : sheetNames.indexOf(sheetName);
  for (let index = entrySheets.length - 1; index >= 0; index -= 1) {
    if (sheetNames.indexOf(entrySheets[index]) < sheetIndex) return index;
  }
  return -1;
}
